module.exports = __webpack_public_path__ + "img/sistemas-operativos.4123a887.jpg";